import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { ApiClientService, Vazna_obavjestenja } from '../../../services/api-client.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-vazna-obavjestenja',
  templateUrl: './vazna-obavjestenja.component.html',
  styleUrls: ['./vazna-obavjestenja.component.scss']
})
export class VaznaObavjestenjaComponent implements OnInit {
  constructor(
    private apiClient: ApiClientService, 
    private cdRef: ChangeDetectorRef, 
    private userService: UserService
  ) {
    this.onDeleteClick = this.onDeleteClick.bind(this);
  }

  startDate: Date = new Date(new Date().toDateString());
  endDate: Date = new Date(new Date(new Date().toDateString()).setHours(23, 59, 59, 999));
  gridData: any[] = [];
  loading: boolean = false;
  loadPanelPosition = { of: '#vaznaObavjestenjaGrid' };
  createVaznaObavjestenjaPopupVisible: boolean = false;
  isUserModerator: boolean = false;

  @ViewChild('vaznaObavjestenjaGrid', { static: false }) vaznaObavjestenjaGrid: DxDataGridComponent;

  ngOnInit() {
    this.isUserModerator = this.userService.isUserAgroModerator();
    console.log('User is moderator:', this.isUserModerator);
  }

  onStartDateChange(event: any) {
    this.startDate = event;
  }

  onEndDateChange(event: any) {
    this.endDate = event;
  }

  isFormValid(): boolean {
    return !!this.startDate && !!this.endDate;
  }

  toLocalAsUTC(date: Date): Date {
    const newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return newDate;
  }

  async loadData() {
    if (!this.isFormValid()) {
      return;
    }

    this.loading = true;
    
    try {
      // Note: The API endpoint for GET might be different, adjust as needed
      // For now, using a similar pattern - you might need to adjust the endpoint
      const result = await this.apiClient.vaznaObavjestenjaAll(this.toLocalAsUTC(this.startDate), this.toLocalAsUTC(this.endDate));
      this.gridData = result;

    } catch (error) {
      console.error('Error loading važna obavještenja data:', error);
    } finally {
      this.loading = false;
    }
  }

  showCreateVaznaObavjestenja() {
    this.createVaznaObavjestenjaPopupVisible = true;
  }

  async onVaznaObavjestenjaCreated(e: Vazna_obavjestenja) {
    await this.loadData();
  }

  async onDeleteClick(e: any) {
    this.loading = true;
    const vaznaObavjestenja = e.row.data;

    try {
      await this.apiClient.vaznaObavjestenjaDELETE(vaznaObavjestenja.id);

      const index = this.gridData.findIndex(item => item.id === vaznaObavjestenja.id);
      if (index > -1) {
        this.gridData.splice(index, 1);
        this.gridData = [...this.gridData]; // Trigger change detection
      }

      this.loading = false;
      this.cdRef.detectChanges();
    } catch (error) {
      this.loading = false;
      console.error('Error deleting važna obavještenja:', error);
    }
  }
}